












































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ModalProcedimentosIncluir extends Vue {
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  loadAddRegraCalculoOperadora: boolean = false
  get loadingAddRegraCalculoOperadora() { return this.loadAddRegraCalculoOperadora }
  set loadingAddRegraCalculoOperadora(value: boolean) { this.loadAddRegraCalculoOperadora = value }

  get showModalAddProcedimentos() { return this.getRegrasDeCalculoStore.modal.procedimentos }
  set showModalAddProcedimentos(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'procedimentos', value }) }

  get valorGarantiaMinima() { return this.getRegrasDeCalculoStore.valorGarantiaMinima }
  set valorGarantiaMinima(value: any) { this.getRegrasDeCalculoStore.setValorGarantiaMinima(value) }

  get criarItemGrupoRepasseDiferente() { return this.getRegrasDeCalculoStore.criarItemGrupoRepasseDiferente }
  set criarItemGrupoRepasseDiferente(value: boolean) { this.getRegrasDeCalculoStore.setCriarItemGrupoRepasseDiferente(value) }

  get grupoRepasse() { return this.getRegrasDeCalculoStore.grupoRepasse }
  set grupoRepasse(value: any) { this.getRegrasDeCalculoStore.setGrupoRepasse(value) }

  get subGrupoRepasse() { return this.getRegrasDeCalculoStore.subGrupoRepasse }
  set subGrupoRepasse(value: any) { this.getRegrasDeCalculoStore.setSubGrupoRepasse(value) }

  get codigoProcedimento() { return this.getRegrasDeCalculoStore.codigoProcedimento }
  set codigoProcedimento(value: any) { this.getRegrasDeCalculoStore.setCodigoProcedimento(value) }

  get descricaoProcedimento() { return this.getRegrasDeCalculoStore.descricaoProcedimento }
  set descricaoProcedimento(value: any) { this.getRegrasDeCalculoStore.setDescricaoProcedimento(value) }

  search: string = ''
  procedimentos: any[] = []
  selectedProcedimento: any = null

  valorGarantiaMinimaRule = (value: any) => !!value || 'O valor é obrigatório.'

  async fetchProcedimentos() {
    try {
      const response = await this.getRegrasDeCalculoStore.getProcedimentos(this.search)
      if (response.success) {
        this.procedimentos = response.data.procedimentos
      } else {
        this.procedimentos = []
      }
    } catch (error) {
      this.procedimentos = []
    }
  }

  async addProcedimento() {
    this.loadingAddRegraCalculoOperadora = true
    const request = await this.getRegrasDeCalculoStore.addProcedimentos()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAddRegraCalculoOperadora = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Procedimento incluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingAddRegraCalculoOperadora = false
    this.showModalAddProcedimentos = false
  }

  async created(){
    await this.getRegrasDeCalculoStore.getGruposRepasse()
  }

  @Watch('showModalAddProcedimentos')
  onChangeShowModalAddRegraCalculoOperadora(value: boolean) {
    if (!value) {
      this.selectedProcedimento = null
      this.valorGarantiaMinima = 0
      this.criarItemGrupoRepasseDiferente = false
      this.grupoRepasse = null
      this.subGrupoRepasse = null
    }
  }

  @Watch('selectedProcedimento')
  onChangeSelectedProcedimento(value: any) {
    if (value) {
      this.codigoProcedimento = value.codigo
      this.descricaoProcedimento = value.descricao
    } else {
      this.codigoProcedimento = ''
      this.descricaoProcedimento = ''
    }
  }

  @Watch('grupoRepasse')
  async onGrupoRepasseChange(novoGrupoId: string | null) {
    if (novoGrupoId) {
      try {
        await this.getRegrasDeCalculoStore.getSubGruposRepasse(novoGrupoId)
      } catch (error) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: 'Erro ao buscar subgrupos de repasse.',
          icon: 'error',
          color: '#C62828',
        })
      }
    }
  }
}
